import type { Agent, GeneratedCase, QualityOverview } from "@/lib/qa-types";

export const demoOverview: QualityOverview = {
    pass_rate: 94.6,
    active_agents: 2,
    queued_runs: 7,
    healed_steps: 38,
    open_defects: 12,
    coverage: 78.4,
    pass_rate_trend: [88, 91.2, 90.1, 93.8, 92.7, 95.2, 94.6],
    defect_modules: { 结算: 8, 登录: 3, 商品: 5, 优惠券: 6, 订单: 2 },
};

export const demoAgents: Agent[] = [
    {
        agent_id: "agent-sh-01",
        name: "上海执行节点 01",
        status: "BUSY",
        labels: ["linux", "chrome", "uat"],
        capacity: 4,
        active_runs: 3,
        last_heartbeat_at: "4 秒前",
    },
    {
        agent_id: "agent-sz-02",
        name: "深圳执行节点 02",
        status: "ONLINE",
        labels: ["linux", "chrome", "edge"],
        capacity: 6,
        active_runs: 2,
        last_heartbeat_at: "7 秒前",
    },
    {
        agent_id: "agent-bj-03",
        name: "北京执行节点 03",
        status: "OFFLINE",
        labels: ["windows", "edge"],
        capacity: 2,
        active_runs: 0,
        last_heartbeat_at: "8 分钟前",
    },
];

export const demoCases: GeneratedCase[] = [
    {
        case_id: "TC-CHECKOUT-001",
        title: "满 100 元使用有效优惠券结算成功",
        category: "positive",
        priority: "P0",
        steps: ["购物车加入 2 件商品", "输入有效优惠券", "提交订单"],
        expected_results: ["优惠金额正确", "订单创建成功"],
    },
    {
        case_id: "TC-CHECKOUT-002",
        title: "过期优惠券被拒绝且保留购物车",
        category: "negative",
        priority: "P1",
        steps: ["准备满额订单", "输入过期优惠券", "点击应用"],
        expected_results: ["显示过期提示", "订单金额不变"],
    },
    {
        case_id: "TC-CHECKOUT-003",
        title: "订单金额 99.99 / 100.00 边界组合",
        category: "boundary",
        priority: "P1",
        steps: ["分别准备边界订单", "应用同一优惠券", "比较结果"],
        expected_results: ["99.99 被拒绝", "100.00 可使用"],
    },
];

export function phaseLabel(phase: string): string {
    const labels: Record<string, string> = {
        idle: "等待开始",
        queued: "已进入 P0 队列",
        running: "Agent 正在执行",
        healing: "发现 DOM 变化，正在自愈",
        passed: "自愈成功 · 执行通过",
    };
    return labels[phase] ?? "未知状态";
}
